import { LinkService } from '@chr/online-shared-microsite-core';

export const RedirectToPageNotFound = () => {
  LinkService.getLinks().then(() => {
    const pageNotFoundLink = LinkService.PAGE_NOT_FOUND;
    if (pageNotFoundLink) {
      window.location.assign(pageNotFoundLink);
    }
  });
  return <></>;
}